import ValidService from '../../../../../service/ValidService';
import LanguageService from '../../../../../service/LanguageService';
let model = {};

// dữ liệu form
model.dataForm = {
    "code": undefined, // required Mã ca
    "name": undefined, // required Tên ca
    "company_id": undefined, // required Công ty Id
    "work_number": undefined, // required Số công
    "work_hour_number": undefined, // required Số giờ công
    "work_number_payment": "WORK", // required, enum(WORK, HOUR) Phương pháp tính công, công hoặc theo giờ
    "is_pass_day": false, // required Qua ngày
    "is_odd_shift": undefined, // required Ca lẻ
    "round_number_h_t_w": undefined, // optional, enum(0.125, 0.25, 0.5, 1.0) Số làm tròn từ giờ sang công
    "applied_start_time": undefined, // required Thời điểm áp dụng
    "applied_end_time": undefined, // optional Thời điểm áp dụng kết thúc
    "odd_names": [], // required Tên ca lẻ
    "work_days": // required 
    [
        {
            "name": undefined, // required Tên thứ
            "period_time": [ // optional 
            {
                "start_time": // optional Bắt đầu
                {
                    "hour": undefined, // optional Giờ
                    "minute": undefined, // optional Phút
                },
                "end_time": // optional Kết thúc
                {
                    "hour": undefined, // optional Giờ
                    "minute": undefined, // optional Phút
                }
            }], 
            "iteration_cycle": undefined, // required, enum(WEEKLY, EVEN_WEEK_OF_MONTH, ODD_WEEK_OF_MONTH, WEEK_1_OF_MONTH, WEEK_2_OF_MONTH, WEEK_3_OF_MONTH, WEEK_4_OF_MONTH, WEEK_5_OF_MONTH, NEAR_LAST_WEEK_OF_MONTH, LAST_WEEK_OF_MONTH) Chu kì lặp hàng tuần, cách tuần chẵn, cách tuần lẻ, tuần 1 của tháng, tuần 2 của tháng, tuần 3 của tháng, tuần 4 của tháng, tuần 5 của tháng, tuần áp cuối của tháng, tuần cuối cùng của tháng
        },
    ],
    "acceptance_time_start": // required Thời gian chấp nhận bắt đầu chấm công
    {
        "hour": undefined, // required Giờ
        "minute": undefined, // required Phut
    },
    "acceptance_time_end": // required Thời gian kết thúc chấm công
    {
        "hour": undefined, // required Giờ
        "minute": undefined, // required Phut
    },
    "acceptance_late_time": undefined, // optional Thời gian quy định chấm công muộn (phút)
    "extra_block_time": undefined, // optional Block tính làm thêm: extra_block_time (phút)
    "acceptance_time_starts": undefined,
    "acceptance_time_ends": undefined
};

// validation form
model.validForm = {
    "code": [
                ValidService.required,
                ValidService.checkSpaceStringCenter,
                {
                    pattern: /^[_a-zA-Z0-9]+$/g,
                    message: LanguageService.lang.valid_script,
                    trigger: "blur"
                },
            ], // required Mã ca
    "name": [
                ValidService.required,
                ValidService.checkSpaceString,
                ValidService.checkVietNameseHaveNumber
            ], // required Tên ca
    "company_id": [ValidService.requiredChange], // required Công ty Id
    "work_number": [
                    ValidService.required,
                    ValidService.checkSpaceString
                ], // required Số công
    "work_hour_number": [ValidService.required,ValidService.checkSpaceString], // required Số giờ công
    "work_number_payment": [ValidService.required, ValidService.requiredChange], // required, enum(WORK, HOUR) Phương pháp tính công, công hoặc theo giờ
    "is_pass_day": [], // required Qua ngày
    "is_odd_shift": [], // required Ca lẻ
    "round_number_h_t_w": [ValidService.required, ValidService.requiredChange], // optional, enum(0.125, 0.25, 0.5, 1.0) Số làm tròn từ giờ sang công
    "applied_start_time": [ValidService.requiredChange], // required Thời điểm áp dụng
    "applied_end_time": [ValidService.requiredChange], // optional Thời điểm áp dụng kết thúc
    "odd_names": [], // required Tên ca lẻ
    "work_days": // required 
    [
        {
            "name": [ValidService.required,ValidService.checkSpaceString], // required Tên thứ
            "period_time": [ // optional 
                {
                    "start_time": // optional Bắt đầu
                    {
                        "hour": [ValidService.required], // optional Giờ
                        "minute": [ValidService.required], // optional Phút
                    },
                    "end_time": // optional Kết thúc
                    {
                        "hour": [ValidService.required], // optional Giờ
                        "minute": [ValidService.required], // optional Phút
                    }
                }
            ],
            "iteration_cycle": [ValidService.required], // required, enum(WEEKLY, EVEN_WEEK_OF_MONTH, ODD_WEEK_OF_MONTH, WEEK_1_OF_MONTH, WEEK_2_OF_MONTH, WEEK_3_OF_MONTH, WEEK_4_OF_MONTH, WEEK_5_OF_MONTH, NEAR_LAST_WEEK_OF_MONTH, LAST_WEEK_OF_MONTH) Chu kì lặp hàng tuần, cách tuần chẵn, cách tuần lẻ, tuần 1 của tháng, tuần 2 của tháng, tuần 3 của tháng, tuần 4 của tháng, tuần 5 của tháng, tuần áp cuối của tháng, tuần cuối cùng của tháng
        }
    ],
    "acceptance_time_start": // required Thời gian chấp nhận bắt đầu chấm công
    {
        "hour": [ValidService.required], // required Giờ
        "minute": [ValidService.required], // required Phut
    },
    "acceptance_time_end": // required Thời gian kết thúc chấm công
    {
        "hour": [ValidService.required], // required Giờ
        "minute": [ValidService.required], // required Phut
    },
    "acceptance_late_time": [ValidService.required,ValidService.checkSpaceString], // optional Thời gian quy định chấm công muộn (phút)
    "extra_block_time": [ValidService.required,ValidService.checkSpaceString], // optional Block tính làm thêm: extra_block_time (phút)
    "acceptance_time_starts": [ValidService.required],
    "acceptance_time_ends": [ValidService.required],
    "list_shift": [],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

model.dataTable = {
    "name": undefined, // required Tên thứ
    "hour_work": undefined,
    "period_time":
    [ 
        {
            "start_time": // optional Bắt đầu
            {
                "hour": undefined, // optional Giờ
                "minute": undefined, // optional Phút
            },
            "end_time": // optional Kết thúc
            {
                "hour": undefined, // optional Giờ
                "minute": undefined, // optional Phút
            }
        },
        {
            "start_time": // optional Bắt đầu
            {
                "hour": undefined, // optional Giờ
                "minute": undefined, // optional Phút
            },
            "end_time": // optional Kết thúc
            {
                "hour": undefined, // optional Giờ
                "minute": undefined, // optional Phút
            }
        }
    ],
    "iteration_cycle": undefined, // required, enum(WEEKLY, EVEN_WEEK_OF_MONTH, ODD_WEEK_OF_MONTH, WEEK_1_OF_MONTH, WEEK_2_OF_MONTH, WEEK_3_OF_MONTH, WEEK_4_OF_MONTH, WEEK_5_OF_MONTH, NEAR_LAST_WEEK_OF_MONTH, LAST_WEEK_OF_MONTH) Chu kì lặp hàng tuần, cách tuần chẵn, cách tuần lẻ, tuần 1 của tháng, tuần 2 của tháng, tuần 3 của tháng, tuần 4 của tháng, tuần 5 của tháng, tuần áp cuối của tháng, tuần cuối cùng của tháng
};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {},
        valid: {},
        operator: {}
    }
};

export default model;